import React, { useState, useCallback, useEffect } from "react";
import { MDialog, ChangePasswordCard } from "components/Shared";

const ExpiredPasswordModal = () => {
  const [visible, setVisible] = useState(false);
  const onHide = useCallback(
    () => {
      if (JSON.parse(sessionStorage.getItem("MustChangePassword"))) {
        setVisible(true);
      } else {
        setVisible(false);
      }
    },
    []
  );

  useEffect(
    () => {
      if (JSON.parse(sessionStorage.getItem("MustChangePassword"))) {
        setVisible(true);
      }
    },
    []
  );

  return (
    <MDialog
      {...{ visible, onHide }}
      id={"ExpiredPasswordModal"}
      contentClassName={"no-padding"}
      ariaLabel={"Password Expired"}
    >
      <ChangePasswordCard />
    </MDialog>
  );
};

export default ExpiredPasswordModal;